import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import Swal from 'sweetalert2';

/**
 * Contrato que el contenedor del registro implementa para que el guard sepa si
 * hay trabajo sin guardar. Se define acá y no se importa el componente para no
 * atar el guard al módulo de auth.
 */
export interface PuedeAbandonarRegistro {
  /** `true` cuando el usuario tiene capturas sin subir y perdería el avance. */
  tieneTrabajoSinGuardar(): boolean;
}

/**
 * Confirma antes de salir del registro cuando hay capturas sin subir.
 *
 * Cubre la navegación interna de Angular, que es la que `beforeunload` NO
 * intercepta: el botón atrás del navegador y cualquier link a otra ruta. El
 * cierre o refresco de la pestaña lo cubre el contenedor con sus
 * `HostListener`, y ahí el navegador muestra su propio texto genérico — por eso
 * este diálogo, que sí puede decir qué se pierde, es la pieza que explica.
 */
@Injectable({
  providedIn: 'root',
})
export class SignupAbandonoGuard
  implements CanDeactivate<PuedeAbandonarRegistro>
{
  async canDeactivate(component: PuedeAbandonarRegistro): Promise<boolean> {
    if (!component?.tieneTrabajoSinGuardar?.()) {
      return true;
    }

    const result = await Swal.fire({
      title: '¿Salir del registro?',
      html: `
        <p>Todavía no guardamos la verificación de identidad.</p>
        <p>Si sales ahora vas a tener que volver a capturar
        <strong>el documento, la selfie y el e-RUT</strong>.</p>
      `,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Salir y perder el avance',
      cancelButtonText: 'Seguir con el registro',
      confirmButtonColor: '#b45309',
      cancelButtonColor: '#0e7705',
      reverseButtons: true,
    });

    return result.isConfirmed;
  }
}
